import { Component } from "@angular/core";

import { TranslateModule } from "@ngx-translate/core";
import { MatDialogRef } from "@angular/material/dialog";
import { UtilityService } from "app/services";
import { DomSanitizer, SafeResourceUrl } from "@angular/platform-browser";
import { SvgIconComponent } from "app/modules/shared/svg-icon/svg-icon.component";

@Component({
  selector: "app-payment-info-video-dialog",
  imports: [TranslateModule, SvgIconComponent],
  templateUrl: "./payment-info-video-dialog.component.html",
  styleUrls: ["./payment-info-video-dialog.component.scss"],
})
export class PaymentInfoVideoDialogComponent {
  videoUrl: SafeResourceUrl;

  constructor(
    public dialogRef: MatDialogRef<PaymentInfoVideoDialogComponent>,
    public utilityService: UtilityService,
    private sanitizer: DomSanitizer,
  ) {
    this.videoUrl = this.sanitizer.bypassSecurityTrustResourceUrl(
      this.utilityService.isNL
        ? "https://www.youtube.com/embed/Cfh6h-KBrIE?autoplay=1&mute=1"
        : "https://www.youtube.com/embed/n7Ym8F4tEgg?autoplay=1&mute=1",
    );
  }

  closeDialog() {
    this.dialogRef.close();
  }
}
